import api from './api';

export const calculatorImportService = {
  // Import leads from calculator sessions
  importLeads: async () => {
    try {
      const response = await api.post('/api/calculator-import');
      return response.data.data;
    } catch (error) {
      console.error('Error importing leads from calculator:', error);
      throw error;
    }
  },

  // Get count of calculator sessions with phone numbers
  getSubmissionCount: async () => {
    try {
      const response = await api.get('/api/calculator-import/count');
      return response.data.data.count;
    } catch (error) {
      console.error('Error getting calculator submission count:', error);
      throw error;
    }
  },

  // Get count of new leads that can be imported from calculator
  getNewLeadsCount: async () => {
    try {
      const response = await api.get('/api/calculator-import/new-count');
      return response.data.data.count;
    } catch (error) {
      console.error('Error getting new calculator leads count:', error);
      throw error;
    }
  }
};

export default calculatorImportService;
